// Redux action types
export const SET = 'one-state-appointments/set';
//This is used to set the patientid in state
export const SETPATIENT = 'one-state-appointments/setpatient';
export const CANCELAPPT = 'one-state-appointments/cancel-appt';
export const PUSHCANCELAPPT = 'one-state-appointments/push-cancel-appt';
export const CONFIRMAPPT = 'one-state-appointments/confirm-appt';
export const UPDATEAPPT = 'one-state-appointments/update-appt';
export const PUSHCONFIRMAPPT = 'one-state-appointments/push-confirm-appt';
export const RESETCANCELNOTIFICATION = 'one-state-appointments/reset-cancel-appt-notification';
export const ADD = 'one-state-appointments/add';
export const REINIT = 'one-state-appointments/reinit';
export const REINITONPATIENTCHANGE = 'one-state-appointments/reinit-on-patient-change';
export const PUSHUPDATEAPPT = 'one-state-appointments/push-update-appt';
